<template>
  <div class="dialog-wrap">
    <el-dialog
      title="基础内容"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="800px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="60px"
      >
        <el-form-item prop="content">
          <!--    <UEeditor
            :setDataStr="dataForm.content_detail"
            @change="initDtaForm"
          /> -->
          <div
            v-html="dataForm.content_detail"
            class="ql-editor ktext"
          ></div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleClose"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { contentOne, contentEdit } from '@/api/query'
import UEeditor from "@/components/UEeditor.vue"


export default {
  components: {
    UEeditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {


      },

      rules: {

      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.fetchDetail(val.id)
      }
    }
  },
  methods: {
    fetchDetail(id) {
      contentOne({ id }).then((res) => {
        this.dataForm = res
      })
    },
    handleSubmit() {
      delete this.dataForm.id
      contentEdit(this.dataForm).then(res => {
        this.$message.success(`修改成功`)
        this.$emit('submit')
        this.handleClose()
      })
    },
    handleClose() {
      this.dataForm = {}
      this.$emit('close')
    },
    initDtaForm(e) {
      /*  this.dataForm.content_detail = e */
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}

.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.cover-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.ref-box {
  /deep/ .el-input__inner {
    border-style: dashed;
  }
}
</style>
